"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _calendar = require("@gravity/calendar");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _input = _interopRequireDefault(require("@gravity/input"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _format = _interopRequireDefault(require("date-fns/format"));
var _get = _interopRequireDefault(require("lodash/get"));
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/DatePicker/lib/DatePicker.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_ia4kn9nhe() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/DatePicker/lib/DatePicker.js";
  var hash = "d390d366c79bff41df04b8d29782ce3cbc804240";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/ui/DatePicker/lib/DatePicker.js",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 16
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "2": {
        start: {
          line: 34,
          column: 21
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "3": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 37,
          column: 97
        }
      },
      "4": {
        start: {
          line: 43,
          column: 23
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "5": {
        start: {
          line: 51,
          column: 31
        },
        end: {
          line: 51,
          column: 84
        }
      },
      "6": {
        start: {
          line: 52,
          column: 29
        },
        end: {
          line: 52,
          column: 82
        }
      },
      "7": {
        start: {
          line: 80,
          column: 21
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "8": {
        start: {
          line: 86,
          column: 27
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "9": {
        start: {
          line: 104,
          column: 20
        },
        end: {
          line: 129,
          column: 1
        }
      },
      "10": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 17
        }
      },
      "11": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 55
        }
      },
      "12": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 71
        }
      },
      "13": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 74
        }
      },
      "14": {
        start: {
          line: 149,
          column: 18
        },
        end: {
          line: 153,
          column: 3
        }
      },
      "15": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 152,
          column: 7
        }
      },
      "16": {
        start: {
          line: 158,
          column: 21
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "17": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 94
        }
      },
      "18": {
        start: {
          line: 159,
          column: 31
        },
        end: {
          line: 159,
          column: 92
        }
      },
      "19": {
        start: {
          line: 165,
          column: 23
        },
        end: {
          line: 171,
          column: 3
        }
      },
      "20": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "21": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 13
        }
      },
      "22": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 28
        }
      },
      "23": {
        start: {
          line: 176,
          column: 24
        },
        end: {
          line: 186,
          column: 3
        }
      },
      "24": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 185,
          column: 6
        }
      },
      "25": {
        start: {
          line: 178,
          column: 19
        },
        end: {
          line: 178,
          column: 80
        }
      },
      "26": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 183,
          column: 9
        }
      },
      "27": {
        start: {
          line: 182,
          column: 10
        },
        end: {
          line: 182,
          column: 36
        }
      },
      "28": {
        start: {
          line: 188,
          column: 17
        },
        end: {
          line: 192,
          column: 3
        }
      },
      "29": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 191,
          column: 5
        }
      },
      "30": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 190,
          column: 39
        }
      },
      "31": {
        start: {
          line: 194,
          column: 21
        },
        end: {
          line: 200,
          column: 3
        }
      },
      "32": {
        start: {
          line: 195,
          column: 17
        },
        end: {
          line: 195,
          column: 62
        }
      },
      "33": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 35
        }
      },
      "34": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 199,
          column: 7
        }
      },
      "35": {
        start: {
          line: 203,
          column: 29
        },
        end: {
          line: 203,
          column: 39
        }
      },
      "36": {
        start: {
          line: 204,
          column: 25
        },
        end: {
          line: 204,
          column: 40
        }
      },
      "37": {
        start: {
          line: 205,
          column: 31
        },
        end: {
          line: 210,
          column: 8
        }
      },
      "38": {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 208,
          column: 7
        }
      },
      "39": {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 207,
          column: 39
        }
      },
      "40": {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 23
        }
      },
      "41": {
        start: {
          line: 211,
          column: 25
        },
        end: {
          line: 217,
          column: 8
        }
      },
      "42": {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 214,
          column: 7
        }
      },
      "43": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 37
        }
      },
      "44": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 24
        }
      },
      "45": {
        start: {
          line: 218,
          column: 20
        },
        end: {
          line: 218,
          column: 78
        }
      },
      "46": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 221,
          column: 5
        }
      },
      "47": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 31
        }
      },
      "48": {
        start: {
          line: 222,
          column: 31
        },
        end: {
          line: 222,
          column: 33
        }
      },
      "49": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 278,
          column: 6
        }
      },
      "50": {
        start: {
          line: 237,
          column: 16
        },
        end: {
          line: 237,
          column: 47
        }
      },
      "51": {
        start: {
          line: 238,
          column: 16
        },
        end: {
          line: 238,
          column: 26
        }
      },
      "52": {
        start: {
          line: 244,
          column: 14
        },
        end: {
          line: 249,
          column: 16
        }
      },
      "53": {
        start: {
          line: 256,
          column: 12
        },
        end: {
          line: 256,
          column: 29
        }
      },
      "54": {
        start: {
          line: 282,
          column: 0
        },
        end: {
          line: 298,
          column: 2
        }
      },
      "55": {
        start: {
          line: 300,
          column: 0
        },
        end: {
          line: 310,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 12
          }
        },
        loc: {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 97
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 23
          }
        },
        loc: {
          start: {
            line: 51,
            column: 31
          },
          end: {
            line: 51,
            column: 84
          }
        },
        line: 51
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 20
          },
          end: {
            line: 52,
            column: 21
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 52,
            column: 82
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 21
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 133
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 3
          }
        },
        loc: {
          start: {
            line: 138,
            column: 22
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 138
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        loc: {
          start: {
            line: 145,
            column: 25
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 145
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 149,
            column: 18
          },
          end: {
            line: 149,
            column: 19
          }
        },
        loc: {
          start: {
            line: 149,
            column: 26
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 149
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 158,
            column: 21
          },
          end: {
            line: 158,
            column: 22
          }
        },
        loc: {
          start: {
            line: 158,
            column: 27
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 158
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 159,
            column: 18
          },
          end: {
            line: 159,
            column: 19
          }
        },
        loc: {
          start: {
            line: 159,
            column: 31
          },
          end: {
            line: 159,
            column: 92
          }
        },
        line: 159
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 165,
            column: 23
          },
          end: {
            line: 165,
            column: 24
          }
        },
        loc: {
          start: {
            line: 165,
            column: 28
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 165
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 176,
            column: 24
          },
          end: {
            line: 176,
            column: 25
          }
        },
        loc: {
          start: {
            line: 176,
            column: 32
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 176
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 178,
            column: 6
          },
          end: {
            line: 178,
            column: 7
          }
        },
        loc: {
          start: {
            line: 178,
            column: 19
          },
          end: {
            line: 178,
            column: 80
          }
        },
        line: 178
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 179,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        },
        loc: {
          start: {
            line: 179,
            column: 12
          },
          end: {
            line: 184,
            column: 7
          }
        },
        line: 179
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 188,
            column: 17
          },
          end: {
            line: 188,
            column: 18
          }
        },
        loc: {
          start: {
            line: 188,
            column: 34
          },
          end: {
            line: 192,
            column: 3
          }
        },
        line: 188
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 194,
            column: 21
          },
          end: {
            line: 194,
            column: 22
          }
        },
        loc: {
          start: {
            line: 194,
            column: 27
          },
          end: {
            line: 200,
            column: 3
          }
        },
        line: 194
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        loc: {
          start: {
            line: 202,
            column: 11
          },
          end: {
            line: 279,
            column: 3
          }
        },
        line: 202
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 205,
            column: 32
          },
          end: {
            line: 205,
            column: 33
          }
        },
        loc: {
          start: {
            line: 205,
            column: 38
          },
          end: {
            line: 210,
            column: 5
          }
        },
        line: 205
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 211,
            column: 26
          },
          end: {
            line: 211,
            column: 27
          }
        },
        loc: {
          start: {
            line: 211,
            column: 32
          },
          end: {
            line: 217,
            column: 5
          }
        },
        line: 211
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 236,
            column: 15
          },
          end: {
            line: 236,
            column: 16
          }
        },
        loc: {
          start: {
            line: 236,
            column: 26
          },
          end: {
            line: 239,
            column: 15
          }
        },
        line: 236
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 243,
            column: 13
          },
          end: {
            line: 243,
            column: 14
          }
        },
        loc: {
          start: {
            line: 244,
            column: 14
          },
          end: {
            line: 249,
            column: 16
          }
        },
        line: 244
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 255,
            column: 20
          },
          end: {
            line: 255,
            column: 21
          }
        },
        loc: {
          start: {
            line: 255,
            column: 28
          },
          end: {
            line: 257,
            column: 11
          }
        },
        line: 255
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 304,
            column: 12
          },
          end: {
            line: 304,
            column: 13
          }
        },
        loc: {
          start: {
            line: 304,
            column: 18
          },
          end: {
            line: 304,
            column: 20
          }
        },
        line: 304
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 167
      },
      "1": {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 17
          }
        }, {
          start: {
            line: 167,
            column: 21
          },
          end: {
            line: 167,
            column: 49
          }
        }],
        line: 167
      },
      "2": {
        loc: {
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 183,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 183,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "3": {
        loc: {
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 189
      },
      "4": {
        loc: {
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 208,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 206
      },
      "5": {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 212
      },
      "6": {
        loc: {
          start: {
            line: 218,
            column: 20
          },
          end: {
            line: 218,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 65
          },
          end: {
            line: 218,
            column: 73
          }
        }, {
          start: {
            line: 218,
            column: 76
          },
          end: {
            line: 218,
            column: 78
          }
        }],
        line: 218
      },
      "7": {
        loc: {
          start: {
            line: 218,
            column: 20
          },
          end: {
            line: 218,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 20
          },
          end: {
            line: 218,
            column: 40
          }
        }, {
          start: {
            line: 218,
            column: 44
          },
          end: {
            line: 218,
            column: 62
          }
        }],
        line: 218
      },
      "8": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 219
      },
      "9": {
        loc: {
          start: {
            line: 227,
            column: 11
          },
          end: {
            line: 227,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 11
          },
          end: {
            line: 227,
            column: 30
          }
        }, {
          start: {
            line: 227,
            column: 34
          },
          end: {
            line: 227,
            column: 50
          }
        }],
        line: 227
      },
      "10": {
        loc: {
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 241,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 228,
            column: 23
          }
        }, {
          start: {
            line: 230,
            column: 12
          },
          end: {
            line: 240,
            column: 28
          }
        }],
        line: 228
      },
      "11": {
        loc: {
          start: {
            line: 247,
            column: 29
          },
          end: {
            line: 247,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 247,
            column: 45
          },
          end: {
            line: 247,
            column: 48
          }
        }, {
          start: {
            line: 247,
            column: 51
          },
          end: {
            line: 247,
            column: 53
          }
        }],
        line: 247
      },
      "12": {
        loc: {
          start: {
            line: 263,
            column: 19
          },
          end: {
            line: 263,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 263,
            column: 19
          },
          end: {
            line: 263,
            column: 35
          }
        }, {
          start: {
            line: 263,
            column: 39
          },
          end: {
            line: 263,
            column: 49
          }
        }],
        line: 263
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d390d366c79bff41df04b8d29782ce3cbc804240"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ia4kn9nhe = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ia4kn9nhe();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_ia4kn9nhe().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-DatePicker'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n"]))));
var DateWrapper = (cov_ia4kn9nhe().s[1]++, _styledComponents.default.div.attrs({
  className: 'g-DatePicker-date'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  .g-Input > input {\n    padding-left: 20px;\n  }\n"]))));
var CalendarIcon = (cov_ia4kn9nhe().s[2]++, (0, _styledComponents.default)(_icon.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 8px;\n  color: ", ";\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  cov_ia4kn9nhe().f[0]++;
  cov_ia4kn9nhe().s[3]++;
  return (0, _polished.lighten)(0.2, (0, _get.default)(props, 'theme.icon.color', _stylingConstants.default.color.baseText));
}, _stylingConstants.default.font.sizeL, _stylingConstants.default.font.sizeM, _stylingConstants.default.font.sizeM));
var DatePickerBody = (cov_ia4kn9nhe().s[4]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-DatePicker-calendar"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      border: 1px solid;\n      border-color: ", ";\n      background: ", ";\n      top: 2.25em;\n      z-index: 101;\n      &.hidden {\n        display: none;\n      }\n      &.embedded {\n        position: relative;\n        top: 0;\n        margin-top: -0.75em;\n      }\n    "])), function (props) {
  cov_ia4kn9nhe().f[1]++;
  cov_ia4kn9nhe().s[5]++;
  return (0, _get.default)(props, 'theme.datePicker.borderColor', '#000000');
}, function (props) {
  cov_ia4kn9nhe().f[2]++;
  cov_ia4kn9nhe().s[6]++;
  return (0, _get.default)(props, 'theme.datePicker.bodyBgColor', '#FFFFFF');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      position: absolute;\n      top: 2.25em;\n      z-index: 101;\n      &.hidden {\n        display: none;\n      }\n      &.embedded {\n        position: relative;\n        top: 0;\n        margin-top: -0.75em;\n      }\n    "]))))));
var InputOverlay = (cov_ia4kn9nhe().s[7]++, _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  width: 100%;\n  height: 2em;\n"]))));
var TodayButtonWrapper = (cov_ia4kn9nhe().s[8]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-FilterBar-today-btn-wrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      display: flex;\n      background-color: #f7f7f7;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      display: flex;\n      margin-top: ", "px;\n    "])), _themeMapper.evolutionTheme.spacings.lg))));
var TodayButton = (cov_ia4kn9nhe().s[9]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_button.default).attrs({
  className: "g-FilterBar-today-btn"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      margin: 5px 0px;\n      border: 0;\n      background: ", ";\n      color: ", ";\n      text-transform: uppercase;\n      font-weight: bold;\n      &:hover,\n      &:focus {\n        background: ", ";\n        color: ", ";\n      }\n      &:hover {\n        opacity: 0.6;\n      }\n    "])), _stylingConstants.default.color.transparent, _stylingConstants.default.color.boxBackground, _stylingConstants.default.color.transparent, _stylingConstants.default.color.boxBackground)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      flex: 1 1 auto;\n    "]))))));

/** Component to display a range of date, adapted to the same day/month/year */
var DatePicker = /*#__PURE__*/function (_Component) {
  function DatePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DatePicker);
    cov_ia4kn9nhe().f[3]++;
    cov_ia4kn9nhe().s[10]++;
    _this = _callSuper(this, DatePicker, [props]);
    (0, _defineProperty2.default)(_this, "onMonthChange", (cov_ia4kn9nhe().s[14]++, function (date) {
      cov_ia4kn9nhe().f[6]++;
      cov_ia4kn9nhe().s[15]++;
      _this.setState({
        month: date
      });
    }));
    /**
     * Method executed when the user clicks in the input (to open/close) or outside the component (to close it)
     */
    (0, _defineProperty2.default)(_this, "toggleVisibility", (cov_ia4kn9nhe().s[16]++, function () {
      cov_ia4kn9nhe().f[7]++;
      cov_ia4kn9nhe().s[17]++;
      _this.setState(function (prevState) {
        cov_ia4kn9nhe().f[8]++;
        cov_ia4kn9nhe().s[18]++;
        return (0, _assign.default)({}, prevState, {
          visible: !prevState.visible
        });
      });
    }));
    /**
     * It manages the clicks outside the component to close it
     */
    (0, _defineProperty2.default)(_this, "handleOutsideClick", (cov_ia4kn9nhe().s[19]++, function (e) {
      cov_ia4kn9nhe().f[9]++;
      cov_ia4kn9nhe().s[20]++;
      // ignore clicks on the component itself
      if ((cov_ia4kn9nhe().b[1][0]++, _this.node) && (cov_ia4kn9nhe().b[1][1]++, _this.node.contains(e.target))) {
        cov_ia4kn9nhe().b[0][0]++;
        cov_ia4kn9nhe().s[21]++;
        return;
      } else {
        cov_ia4kn9nhe().b[0][1]++;
      }
      cov_ia4kn9nhe().s[22]++;
      _this.toggleVisibility();
    }));
    /**
     * It handler the click inside the calendar to fill the input with the new date
     */
    (0, _defineProperty2.default)(_this, "handleClickCalendar", (cov_ia4kn9nhe().s[23]++, function (date) {
      cov_ia4kn9nhe().f[10]++;
      cov_ia4kn9nhe().s[24]++;
      _this.setState(function (prevState) {
        cov_ia4kn9nhe().f[11]++;
        cov_ia4kn9nhe().s[25]++;
        return (0, _assign.default)({}, prevState, {
          visible: !prevState.visible
        });
      }, function () {
        cov_ia4kn9nhe().f[12]++;
        cov_ia4kn9nhe().s[26]++;
        // It passes the day selected to the parent component
        if (_this.props.onChange) {
          cov_ia4kn9nhe().b[2][0]++;
          cov_ia4kn9nhe().s[27]++;
          _this.props.onChange(date);
        } else {
          cov_ia4kn9nhe().b[2][1]++;
        }
      });
    }));
    (0, _defineProperty2.default)(_this, "handleChange", (cov_ia4kn9nhe().s[28]++, function (event, info) {
      cov_ia4kn9nhe().f[13]++;
      cov_ia4kn9nhe().s[29]++;
      if (_this.props.onChange) {
        cov_ia4kn9nhe().b[3][0]++;
        cov_ia4kn9nhe().s[30]++;
        _this.props.onChange(event, info);
      } else {
        cov_ia4kn9nhe().b[3][1]++;
      }
    }));
    (0, _defineProperty2.default)(_this, "handleTodayClick", (cov_ia4kn9nhe().s[31]++, function () {
      cov_ia4kn9nhe().f[14]++;
      var date = (cov_ia4kn9nhe().s[32]++, (0, _format.default)(Date().toLocaleString(), 'YYYY-MM-DD'));
      cov_ia4kn9nhe().s[33]++;
      _this.handleClickCalendar(date);
      cov_ia4kn9nhe().s[34]++;
      _this.setState({
        month: date
      });
    }));
    cov_ia4kn9nhe().s[11]++;
    _this.state = {
      month: props.date,
      visible: false
    };
    return _this;
  }
  (0, _inherits2.default)(DatePicker, _Component);
  return (0, _createClass2.default)(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_ia4kn9nhe().f[4]++;
      cov_ia4kn9nhe().s[12]++;
      document.addEventListener('click', this.handleOutsideClick, false);
    }

    /**
     * Method to remove the event when the component is removed from the DOM
     */
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_ia4kn9nhe().f[5]++;
      cov_ia4kn9nhe().s[13]++;
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_ia4kn9nhe().f[15]++;
      var _ref = (cov_ia4kn9nhe().s[35]++, this.props),
        themeQueries = _ref.themeQueries;
      var selectedDate = (cov_ia4kn9nhe().s[36]++, this.props.date);
      var todayButtonVariant = (cov_ia4kn9nhe().s[37]++, function () {
        cov_ia4kn9nhe().f[16]++;
        cov_ia4kn9nhe().s[38]++;
        if (themeQueries.EVOLUTION) {
          cov_ia4kn9nhe().b[4][0]++;
          cov_ia4kn9nhe().s[39]++;
          return _button.ButtonVariant.secondary;
        } else {
          cov_ia4kn9nhe().b[4][1]++;
        }
        cov_ia4kn9nhe().s[40]++;
        return undefined;
      }());
      var calendarIcon = (cov_ia4kn9nhe().s[41]++, function () {
        cov_ia4kn9nhe().f[17]++;
        cov_ia4kn9nhe().s[42]++;
        if (themeQueries.EVOLUTION) {
          cov_ia4kn9nhe().b[5][0]++;
          cov_ia4kn9nhe().s[43]++;
          return 'riCalendarEventLine';
        } else {
          cov_ia4kn9nhe().b[5][1]++;
        }
        cov_ia4kn9nhe().s[44]++;
        return 'calendar';
      }());
      var className = (cov_ia4kn9nhe().s[45]++, (cov_ia4kn9nhe().b[7][0]++, !this.props.embedded) && (cov_ia4kn9nhe().b[7][1]++, this.state.visible) ? (cov_ia4kn9nhe().b[6][0]++, 'hidden') : (cov_ia4kn9nhe().b[6][1]++, ''));
      cov_ia4kn9nhe().s[46]++;
      if (this.props.embedded) {
        cov_ia4kn9nhe().b[8][0]++;
        cov_ia4kn9nhe().s[47]++;
        className += ' embedded';
      } else {
        cov_ia4kn9nhe().b[8][1]++;
      }
      var selectedDateFormated = (cov_ia4kn9nhe().s[48]++, '');
      cov_ia4kn9nhe().s[49]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 225,
          columnNumber: 7
        }
      }), /*#__PURE__*/_react.default.createElement(DateWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 226,
          columnNumber: 9
        }
      }, (cov_ia4kn9nhe().b[9][0]++, this.props.embedded) && (cov_ia4kn9nhe().b[9][1]++, /*#__PURE__*/_react.default.createElement(InputOverlay, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 227,
          columnNumber: 35
        }
      })), (cov_ia4kn9nhe().b[10][0]++, selectedDate) && (cov_ia4kn9nhe().b[10][1]++,
      /*#__PURE__*/
      // set the selectedDate format using the correct language
      _react.default.createElement(_reactIntl.FormattedDate, {
        value: selectedDate,
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "UTC",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 230,
          columnNumber: 13
        }
      }, function (selDate) {
        cov_ia4kn9nhe().f[18]++;
        cov_ia4kn9nhe().s[50]++;
        selectedDateFormated = selDate;
        cov_ia4kn9nhe().s[51]++;
        return '';
      })), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.Datepicker.placeholder',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 242,
          columnNumber: 11
        }
      }, function (msg) {
        cov_ia4kn9nhe().f[19]++;
        cov_ia4kn9nhe().s[52]++;
        return /*#__PURE__*/_react.default.createElement(_input.default, {
          onChange: _this2.handleChange,
          onClick: _this2.toggleVisibility,
          placeholder: !selectedDate ? (cov_ia4kn9nhe().b[11][0]++, msg) : (cov_ia4kn9nhe().b[11][1]++, ''),
          value: selectedDateFormated,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 244,
            columnNumber: 15
          }
        });
      }), /*#__PURE__*/_react.default.createElement(CalendarIcon, {
        iconName: calendarIcon,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 252,
          columnNumber: 11
        }
      })), /*#__PURE__*/_react.default.createElement(DatePickerBody, {
        innerRef: function innerRef(node) {
          cov_ia4kn9nhe().f[20]++;
          cov_ia4kn9nhe().s[53]++;
          _this2.node = node;
        },
        className: className,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 254,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_calendar.MiniCalendar, {
        datePicker: true,
        onClick: this.handleClickCalendar,
        selectedDay: selectedDate,
        month: (cov_ia4kn9nhe().b[12][0]++, this.state.month) || (cov_ia4kn9nhe().b[12][1]++, new Date()),
        onMonthChange: this.onMonthChange,
        showPastDates: this.props.showPastDates,
        hideBeforeDate: this.props.hideBeforeDate,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 259,
          columnNumber: 11
        }
      })), /*#__PURE__*/_react.default.createElement(TodayButtonWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 269,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(TodayButton, {
        variant: todayButtonVariant,
        small: themeQueries.EQUILIBRIUM,
        onClick: this.handleTodayClick,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 270,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.Section.relativeDay.today',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 274,
          columnNumber: 13
        }
      }))));
    }
  }]);
}(_react.Component);
cov_ia4kn9nhe().s[54]++;
DatePicker.propTypes = {
  /** the initial date */
  date: _propTypes.default.string,
  /** Format used to display the date in the input field */
  format: _propTypes.default.string,
  /** True if we want to display the calendar visible all the time, also the input will not be clickable */
  embedded: _propTypes.default.bool,
  /** Method to handler the change event */
  onChange: _propTypes.default.func,
  /** True if we want to display past dates in the calendar */
  showPastDates: _propTypes.default.bool,
  /** Date that want to hide all date before this date (not hide this date) */
  hideBeforeDate: _propTypes.default.instanceOf(Date),
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_ia4kn9nhe().s[55]++;
DatePicker.defaultProps = {
  date: null,
  format: 'MMMM DD YYYY',
  embedded: false,
  onChange: function onChange() {
    cov_ia4kn9nhe().f[21]++;
  },
  showPastDates: false,
  hideBeforeDate: null,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(DatePicker));